import React from "react";
import SampleDashboardLayout from "./SampleDashboardLayout";
import Chat from "../../../components/Chat/Chat";

const SampleChat = () => {
  return (
    <>
      <SampleDashboardLayout>
        <Chat />
      </SampleDashboardLayout>
    </>
  );
};

export default SampleChat;
